import React, { Component } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { auth, users } from "data/actions";

import Field from 'components/Form/Field';
import Row from 'components/Form/Row';
import RaisedButton from 'material-ui/RaisedButton';

class SMSAuth extends Component {

  defaultState = {
    code:'',
    digits: ["","","","","",""],
    position: 0
  }
  state = {...this.defaultState}

  _handleEscKey = (event) => {
    if(event.keyCode == 27){
    }
    if(event.key == "Backspace"){
      if (this.state.position > 0)
      {
        var digits = [...this.state.digits]    
        var position = this.state.position-1
        digits[position] = "";  
        this.setState({...this.state, digits, position})
      }
    }
    if (event.keyCode >= 48 && event.keyCode <= 58 && this.state.position < 6 )
    {
      var number = event.keyCode - 48;
      var position = this.state.position
      var digits = [...this.state.digits]    
      digits[position] = number;
      position++;
      this.setState({...this.state, digits, position })
    }
  }
  componentWillMount = () => {
    document.addEventListener("keydown", this._handleEscKey, false);
  }


  componentWillUnmount = () => {
    document.removeEventListener("keydown", this._handleEscKey, false);
  }

  handleLogout = (e) => {
    e.preventDefault();
    this.setState(this.defaultState);    
    this.props.actions.logout();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.actions.smsauth(this.props.user, parseInt(this.state.digits.join("")));
  }

  resetActivationCode = (e) => {
    e.preventDefault();
    this.setState(this.defaultState);
    
    this.props.actions.resetActivationCode(this.props.user);
  }

  onSubmit = (e) => {
    e.preventDefault();
  }

  render () {
    if (this.props.user && this.props.user.activated )
    {
      return null;
    }
    return (
      <div className="sms_auth">
        <div className="sms_auth__form">
          <div className="sms_auth__form__instruction">Fyll i den sexsiffriga aktiveringskod vi skickat till din mobil.</div>
          <div className="sms_auth__form__digits">
            {this.state.digits.map((d,idx) => (<span key={idx}>{d}</span>))}
          </div>
          <div className="sms_auth__form__button">
            <RaisedButton onTouchTap={this.handleLogout} disabled={this.props.waiting}  label="Logga ut" />
            <RaisedButton onTouchTap={this.resetActivationCode} disabled={this.props.waiting}  label="Skicka om kod" />
            
            <RaisedButton onTouchTap={this.handleSubmit} disabled={this.props.waiting} primary={true}  label="Aktivera konto" />
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    waiting: state.auth.waiting,
  };
}
const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(
      { ...auth, ...users },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatch)(SMSAuth)

  



// WEBPACK FOOTER //
// ./src/components/Auth/SMSAuth.jsx